import "./FormView.scss"
import React, {Component} from 'react';
import {Form, Input, Select, Button, Radio, Upload, Checkbox, DatePicker, Row, Col, Spin, message, Modal} from 'antd';
import {
    DatabaseOutlined,
    MailOutlined,
    MobileOutlined,
    InboxOutlined,
    WechatOutlined, QqOutlined
} from '@ant-design/icons';
import formBanner from "../../sources/images/form-banner.png"
import {getUrlParams} from "../../utils/index"
import cookies from 'react-cookies'

const CheckboxGroup = Checkbox.Group;
const {Dragger} = Upload;
const {TextArea} = Input;
const {Option} = Select;

const fromCode = {
    "CHN": "Dj1sDzOJDjyeZllj",
    "FOR": "P1PqyTgu1jmQYVxb"
};
const prefixSelector = (id, options) => {
    return (
        <Form.Item name={'areaCode' + id} noStyle>
            <Select style={{width: 120}} optionLabelProp="'+' + label">
                {
                    options.map(item => {
                        return <Option key={item.value} value={item.value}>{item.label}</Option>
                    })
                }
            </Select>
        </Form.Item>
    )
};
const normFile = e => {
    let fileList = [...e.fileList];
    fileList = fileList.length > 1 ? fileList.slice(-1) : fileList;
    fileList = fileList.map(file => {
        if (file.response) {
            file.url = file.response.data[0];
        }
        return file;
    });
    return fileList
};
const createEmailValidateRule = data => {
    let baseRule = [
        {
            required: data.validate1 === 1,
            message: "邮箱不能为空"
        }
    ];
    return data.row_format && JSON.parse(data.row_format).validate === 1 ? baseRule.concat([
        {
            pattern: '^([a-zA-Z]|[0-9])(\\w|\\-)+@[a-zA-Z0-9]+\\.([a-zA-Z]{2,4})$',
            message: "邮箱格式不正确"
        }]) : baseRule
};

const createMaxSizeValidateRule = data => {
    let baseRule = [
        {
            required: data.validate1 === 1,
            message: "请填写" + data.title
        }
    ];
    return data.row_format && JSON.parse(data.row_format).maxSize > 0 ? baseRule.concat([
        {
            type: "string",
            max: +JSON.parse(data.row_format).maxSize,
            message: `最多${JSON.parse(data.row_format).maxSize}个字数`,
            validateTrigger: 'onChange'
        }]) : baseRule
};

const createSchoolValidateRule = (data) => {
    let baseRule = [
        {
            required: data.validate1 === 1,
            message: "请填写" + data.title
        }
    ];
    return baseRule;
}

const debounce = (func, wait) => {
    let timeout;
    return function () {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

class FormView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value1: 1,
            baseInfo: {},
            layout: {},
            show: false,
            areaCode: [],
            items: [],
            tk: "",
            id: 0,
            query: null,
            validateButtonText: "获取验证码",
            dialogVisible: false,
            schoolNameList: []
        };
        this.formRef = React.createRef();
        this.debouncedSearch = debounce(this.getSchoolName, 1000);
    }

    componentDidMount() {
        document.title = "";
        this.setState({
            id: this.props.match.params.id,
            query: getUrlParams(this.props.location.search)
        }, () => {
            this.getFormData();
            this.getAreaCode();
        });
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return false;
        };

    }

    getFormData() {
        React.$axios.request({
            url: "/home/form/" + this.state.id
        }).then(res => {
            console.log(res, '----')
            if (res.code === 200) {
                let baseInfo = {...this.state.baseInfo};
                let {front_end_type, name, callback_type, callback_content, background, sms_secret} = res.data.baseInfo;
                baseInfo.front_style = front_end_type;
                baseInfo.name = name;
                baseInfo.background = background;
                baseInfo.callback_type = callback_type;
                baseInfo.callback_content = callback_content;
                baseInfo.sms_secret = sms_secret ? sms_secret : fromCode.CHN;
                document.title = name;
                this.setState({
                    show: true,
                    baseInfo,
                    layout: res.data.items,
                    items: res.data.items.map(item => {
                        return {
                            ...item,
                            id: item.id,
                            type: this.getElementType(item),
                            value: "",
                            selectFormItem: this.handleSelectItem(item)
                        }
                    })
                }, () => {
                    console.log(this.state)
                })

            }
        })
    }


    // 请求学校
    handleSearch = (value) => {
        this.debouncedSearch(value);
    }

    getSchoolName = (value) => {
        React.$axios.request({
            url: "https://bd.gaodun.cn/emkt/api/v1/school?name=" + value
        }).then(res => {
            if (res.status === 0) {
                this.setState({
                    schoolNameList: res.result
                })
            }
        })
    }


    // 处理当form_item是select时的数据
    handleSelectItem(item) {
        let selectFormItem = [];
        if (item.type === 'select' || item.type === 12) {
            let transData = item.field_type_value ? JSON.parse(item.field_type_value) : null

            // console.log(Object.entries(JSON.parse(item.field_type_value)))

            if (transData && typeof transData == 'object') {
                Object.keys(transData).forEach(trans => {
                    selectFormItem.push(transData[trans])
                })
            }
        }
        // console.log(selectFormItem)
        return selectFormItem;
    }

    getAreaCode() {
        React.$axios.request({
            url: "/home/smscode"
        }).then(res => {
            if (res.code === 200) {
                this.setState({
                    areaCode: res.data.map(item => {
                        return {
                            label: item.area_name + " " + item.code,
                            value: item.code
                        }
                    })
                })
            }
        })
    }

    setTime(id) {
        this.setState({
            ['validate' + id]: true
        });
        var count = 60;
        var resend = setInterval(() => {
            if (count > 0) {
                this.setState({
                    validateButtonText: `${count}s`
                }, () => {
                    count--;
                });

            } else {
                this.setState({
                    validateButtonText: "获取验证码"
                }, () => {
                    count = 60;//倒计时自减
                });
                this.setState({
                    ['validate' + id]: false
                });
                clearInterval(resend);
            }
            cookies.save("msgtime", count);
        }, 1000)
    }

    handleGetMsg(e, index) {
        e.stopPropagation();
        let fieldValues = this.formRef.current.getFieldValue();
        let eleId = this.state.items[index].id;
        let areaCode = fieldValues['areaCode' + eleId].slice(1);
        let phone = fieldValues[eleId];
        if (!areaCode) {
            message.error("请选择地区码！");
            return false
        }
        if (!phone) {
            message.error("请填写手机号！");
            return false
        }
        this.setTime(eleId);
        React.$axios.request({
            url: "https://sms-server.gaodun.com/index.php",
            method: "POST",
            data: {
                from: areaCode === "86" ? this.state.baseInfo.sms_secret : fromCode.FOR,
                act: 'chk',
                phone: areaCode === "86" ? phone : areaCode + parseInt(phone),
                area: areaCode === "86" ? 0 : 1
            }
        }).then(res => {
            if (res.code === 200) {
                this.setState({
                    tk: res.data.tk || ""
                });
            }
        })
    }

    // 获取form_item的类型
    getElementType(data) {
        let type = data.attribute || data.field_type + 6;
        type = data.type === "select" ? 12 : type;
        if (data.alias_crm_key === 'customerInfo.schoolId') {
            type = 13
        }
        return type;
    }

    handleDialogCancel() {
        this.setState({
            dialogVisible: false
        })
    }

    onFinish = values => {
        let phoneId = this.state.items.filter(item => item.type === 3).length ? this.state.items.filter(item => item.type === 3)[0].id : "";
        let areaCode = values['areaCode' + phoneId] && (values['areaCode' + phoneId].slice(1) || "");
        let phone = values[phoneId] || "";
        let phoneValidate = this.state.layout.filter(item => item.id === phoneId).length && JSON.parse(this.state.layout.filter(item => item.id === phoneId)[0].row_format).validate === 1;
        let submitDataArr = this.state.items.map(item => {
            if (item.type === 3) {
                values[item.id] = +values['areaCode' + phoneId] === 86 ? values[item.id] : areaCode + "-" + values[item.id]
            }
            if (item.type === 6) {
                values[item.id] = values[item.id].format('YYYY-MM-DD')
            }

            if (item.type === 9 && values[item.id]) {
                values[item.id] = values[item.id][0].url
            }

            return {
                ['filed' + item.id]: values[item.id]
            }
        });
        let submitData = {};
        submitDataArr.forEach(item => {
            submitData[Object.keys(item)[0]] = Object.values(item)[0]
        });

        const subData = {
            ...submitData,
            sms_info: JSON.stringify({
                from: (phoneId && phoneValidate) ? (areaCode === "86" ? fromCode.CHN : fromCode.FOR) : "",
                act: (phoneId && phoneValidate) ? "chktel" : "",
                phone: phoneId ? (areaCode === "86" ? phone : areaCode + parseInt(phone)) : "",
                pcode: (phoneId && phoneValidate) ? values['validate' + phoneId] : "",
                tk: this.state.tk
            }),
            form_id: this.state.id,
            source: this.state.query.source
        }

        React.$axios.request({
            url: "/api/InsertForm/json",
            method: "post",
            data: subData
        }).then(res => {
            const {callback_type, callback_content} = this.state.baseInfo;
            if (res.code === 200) {
                this.formRef.current.resetFields();
                setTimeout(() => {
                    if (callback_type === 1) {
                        this.props.history.push({pathname: '/Feedback/' + this.state.id});
                    } else if (callback_type === 2) {
                        this.setState({
                            dialogVisible: true
                        })
                    } else if (callback_type === 3) {
                        window.location.href = callback_content
                    } else {
                        message.success("提交成功！");
                    }
                }, 100);
            }
        });

    };
    onFinishFailed = (err) => {
        message.error("提交失败！")
    };

    beforeUpload(file, fileList, format) {
        if (file.size > format.maxSize * 1024 * 1024) {
            message.error("上传文件最大为" + (format.maxSize) + "MB！");
            return false
        }
        if (format.Format.split(",").indexOf(file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase()) < 0) {
            message.error("文件格式不匹配！");
            return false;
        }
        return true
    }

    iconsType(key) {
        let icon = "";
        switch (key) {
            case 'weChat' :
                icon = <WechatOutlined/>
                break;
            case 'qqNumber' :
                icon = <QqOutlined/>
                break;
            case 'mobile' :
                icon = <MobileOutlined/>
                break;
            case 'email' :
                icon = <MailOutlined/>
                break;
            default:
                icon = null;
        }
        return icon;
    }

    render() {
        let {name, front_style, background} = this.state.baseInfo;

        let initialValues = {};
        this.state.items.filter(item => item.type === 3).forEach(item => {
            initialValues['areaCode' + item.id] = "+86"
        });
        return (this.state.show ? <div style={{
            'height': '100%',
            'overflow': 'auto',
            'background': 'url(' + background + ') center no-repeat',
            'backgroundSize': 'cover'
        }}>
            <div className="form-view">
                <div className="form-banner">
                    <img src={formBanner} alt=""/>
                    <span className="form-title">{name}</span>
                </div>
                <div className="form-area">
                    <Form
                        ref={this.formRef}
                        layout="vertical"
                        initialValues={initialValues}
                        scrollToFirstError
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed.bind(this)}>
                        {
                            // eslint-disable-next-line array-callback-return
                            this.state.items.map((item, index) => {
                                switch (item.type) {
                                    case 1:
                                        return <Form.Item
                                            rules={createEmailValidateRule(item)}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <Input prefix={<MailOutlined className="prefix-email"/>}
                                                   placeholder={item.placeholder}/>
                                        </Form.Item>;
                                    case 2:
                                        return <Form.Item rules={[
                                            {
                                                required: item.validate1 === 1,
                                                message: "请选择您的年龄段"
                                            }
                                        ]}
                                                          key={item.id}
                                                          name={item.id}
                                                          label={item.title}>
                                            {
                                                front_style === 1 ? <Radio.Group className="radio-group-type-1">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio className="radio-group-item-1"
                                                                              key={item[0]}
                                                                              value={item[0]}>{item[1]}</Radio>
                                                            })
                                                        }
                                                    </Radio.Group> :
                                                    <Radio.Group className="radio-group-type-2"
                                                                 buttonStyle="solid">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio.Button className="radio-group-item-2"
                                                                                     key={item[0]}
                                                                                     value={item[1].key}>{item[1].value}</Radio.Button>
                                                            })
                                                        }
                                                    </Radio.Group>
                                            }
                                        </Form.Item>;
                                    case 3:
                                        return <Form.Item key={item.id}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: item.validate1 === 1,
                                                        message: "请填写手机号"
                                                    },
                                                    {
                                                        pattern: "^1[3456789]\\d{9}$",
                                                        message: "手机格式不正确"
                                                    }
                                                ]}
                                                required={item.validate1 === 1}
                                                style={{marginBottom: "5px"}}
                                                name={item.id}
                                                label={item.title}
                                            >
                                                <Input
                                                    addonBefore={prefixSelector(item.id, this.state.areaCode)}
                                                    prefix={<MobileOutlined/>} placeholder={item.placeholder}/>
                                            </Form.Item>
                                            {
                                                (item.row_format && JSON.parse(item.row_format).validate === 1) ?
                                                    <Form.Item
                                                        name={'validate' + item.id}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "请输入验证码"
                                                            }]}
                                                        style={{marginBottom: "0"}}
                                                    >
                                                        <Input style={{
                                                            'marginTop': '5px',
                                                            'width': '40%',
                                                            'minWidth': '180px'
                                                        }} placeholder="验证码" suffix={
                                                            <Button type="link"
                                                                    disabled={this.state['validate' + item.id]}
                                                                    onClick={e => this.handleGetMsg(e, index)}>{this.state.validateButtonText}</Button>
                                                        }/>
                                                    </Form.Item> : null
                                            }
                                        </Form.Item>;
                                    case 4:
                                        return <Form.Item rules={[
                                            {
                                                required: item.validate1 === 1,
                                                message: "请选择性别"
                                            }
                                        ]}
                                                          key={item.id}
                                                          name={item.id}
                                                          label={item.title}>
                                            {
                                                front_style === 1 ? <Radio.Group className="radio-group-type-1">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio className="radio-group-item-1"
                                                                              key={item[0]}
                                                                              value={item[1].key}>{item[1].value}</Radio>
                                                            })
                                                        }
                                                    </Radio.Group> :
                                                    <Radio.Group className="radio-group-type-2"
                                                                 buttonStyle="solid">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio.Button className="radio-group-item-2"
                                                                                     key={item[0]}
                                                                                     value={item[1].key}>{item[1].value}</Radio.Button>
                                                            })
                                                        }
                                                    </Radio.Group>
                                            }
                                        </Form.Item>;
                                    case 5:
                                        return <Form.Item
                                            rules={[
                                                {
                                                    required: item.validate1 === 1,
                                                    message: "请填写所在城市"
                                                }
                                            ]}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <Input prefix={<DatabaseOutlined className="prefix-city"/>}
                                                   placeholder={item.placeholder}/>
                                        </Form.Item>;
                                    case 6:
                                        return <Form.Item
                                            rules={[
                                                {
                                                    required: item.validate1 === 1,
                                                    message: "请选择日期"
                                                }
                                            ]}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <DatePicker format="YYYY-MM-DD" placeholder={item.placeholder}/>
                                        </Form.Item>;
                                    case 7:
                                        return <Form.Item rules={[
                                            {
                                                required: item.validate1 === 1,
                                                message: "请选择" + item.title
                                            }
                                        ]}
                                                          key={item.id}
                                                          name={item.id}
                                                          label={item.title}>
                                            {
                                                front_style === 1 ? <Radio.Group className="radio-group-type-1">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio className="radio-group-item-1"
                                                                              key={item[0]}
                                                                              value={item[1].key}>{item[1].value}</Radio>
                                                            })
                                                        }
                                                    </Radio.Group> :
                                                    <Radio.Group className="radio-group-type-2"
                                                                 buttonStyle="solid">
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Radio.Button className="radio-group-item-2"
                                                                                     key={item[0]}
                                                                                     value={item[1].key}>{item[1].value}</Radio.Button>
                                                            })
                                                        }
                                                    </Radio.Group>
                                            }
                                        </Form.Item>;
                                    case 8:
                                        return <Form.Item rules={[
                                            {
                                                required: item.validate1 === 1,
                                                message: "请选择" + item.title
                                            }
                                        ]}
                                                          key={item.id}
                                                          name={item.id}
                                                          label={item.title}>
                                            {
                                                front_style === 1 ? <Checkbox.Group className="checkbox-group-type-1"
                                                                                    style={{width: '100%'}}>
                                                    <Row>
                                                        {
                                                            item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                                return <Col span={24} key={item[0]}>
                                                                    <Checkbox className="checkbox-group-item-1"
                                                                              value={item[1].key}>{item[1].value}</Checkbox>
                                                                </Col>
                                                            })
                                                        }

                                                    </Row>
                                                </Checkbox.Group> : <CheckboxGroup
                                                    className="checkbox-group-type-2"
                                                    options={item.field_type_value && Object.entries(JSON.parse(item.field_type_value)).map(item => {
                                                        return {
                                                            label: item[1].value,
                                                            value: item[1].key
                                                        }
                                                    })}
                                                />
                                            }
                                        </Form.Item>;
                                    case 9:
                                        return <Form.Item
                                            rules={[
                                                {
                                                    required: item.validate1 === 1,
                                                    message: "请上传" + item.title
                                                }
                                            ]}
                                            key={item.id}
                                            name={item.id}
                                            valuePropName="fileList"
                                            getValueFromEvent={normFile}
                                            label={item.title}
                                        >
                                            <Dragger
                                                action="/api/Upload"
                                                name="zip[]"
                                                beforeUpload={(file, fileList) => {
                                                    return this.beforeUpload(file, fileList, JSON.parse(item.row_format))
                                                }}>
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined/>
                                                </p>
                                                <p className="ant-upload-text">点击此处上传</p>
                                                <p className="ant-upload-hint">支持扩展名：{item.row_format && JSON.parse(item.row_format).Format}</p>
                                            </Dragger>
                                        </Form.Item>;
                                    case 10:
                                        return <Form.Item
                                            rules={createMaxSizeValidateRule(item)}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <Input
                                                prefix={this.iconsType(item.alias_crm_key)}
                                                placeholder={item.placeholder + item.title}/>
                                        </Form.Item>;
                                    case 11:
                                        return <Form.Item
                                            rules={createMaxSizeValidateRule(item)}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <TextArea rows={4} placeholder={item.placeholder}/>
                                        </Form.Item>;
                                    case 12:
                                        return <Form.Item
                                            rules={createMaxSizeValidateRule(item)}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp="children"
                                                allowClear
                                            >
                                                {
                                                    item.selectFormItem.length > 0 && item.selectFormItem.map((list, index) => {
                                                        return <Option value={list.key}
                                                                       key={index}>{list.value}</Option>
                                                    })
                                                }
                                            </Select>
                                        </Form.Item>;
                                    case 13:
                                        return <Form.Item
                                            rules={createSchoolValidateRule(item)}
                                            key={item.id}
                                            name={item.id}
                                            label={item.title}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp="name"
                                                allowClear
                                                fieldNames={{label: 'name', value: 'sid'}}
                                                onSearch={this.handleSearch}
                                                options={this.state.schoolNameList}
                                            >
                                            </Select>
                                        </Form.Item>;

                                    default:
                                        break;
                                }
                            })
                        }
                        <Form.Item style={{textAlign: 'center'}}>
                            <Button type="primary" size={"large"} block htmlType="submit">提交</Button>
                        </Form.Item>
                    </Form>
                </div>
                <Modal
                    title="温馨提示"
                    onCancel={this.handleDialogCancel.bind(this)}
                    open={this.state.dialogVisible}
                    footer={null}
                >
                    <div className="ck ck-content">
                        <p dangerouslySetInnerHTML={{__html: this.state.baseInfo.callback_content}}/>
                    </div>
                </Modal>
            </div>
        </div> : <div className="loading"><Spin className="spin" tip="Loading..."/></div>);
    }
}

export default FormView
